export default [
  {
    path: 'accounts/users',
    name: 'Users',
    component: () => import('./views/Users.vue'),
  },
  {
    path: 'accounts/users/new',
    name: 'AddUser',
    component: () => import('./views/AddUser.vue'),
  },
  {
    path: 'accounts/users/:id',
    name: 'UserDetail',
    component: () => import('./views/UserDetail.vue'),
  }
];